import React, { useEffect, useRef, useState } from 'react';
import './PageForJobApply.scss';
import '../../pages/styles.scss';
import mainImage from '../../../assets/images/Community/job-page-main.png';
import plusIcon from '../../../assets/images/plus-icon.svg';
import JobApplicationForm from '../../../components/reusable/JobApplicationForm/JobApplicationForm.js';
import CommonInsuranceSection from '../../../components/reusable/HomePageSections/CommonInsuranceSection/CommonInsuranceSection.js';
import FooterSection from '../../../components/reusable/HomePageSections/FooterSection/FooterSection.js';
import { JOB_SPECIFIC_FIELDS, jobListings } from '../../../components/reusable/Common/Constant.js';
import { useLocation } from 'react-router-dom';

const PageForJobApply = () => {
    const [shouldScroll, setShouldScroll] = useState(false);
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const jobTitle = searchParams.get('jobTitle');
    const decodedJobTitle = decodeURIComponent(jobTitle);
    const job = jobListings[decodedJobTitle];
    const jobSpecificFields = JOB_SPECIFIC_FIELDS[decodedJobTitle] || [];

    const formRef = useRef(null); // Use ref to point to the form element

    const scrollToForm = () => {
        if (formRef.current) {
            formRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    useEffect(() => {
        document.documentElement.scrollTo({
            top: 0,
            left: 0,
            behavior: 'instant'
        });
        document.body.scrollTo({
            top: 0,
            left: 0,
            behavior: 'instant'
        });
    }, [location.search]);

    useEffect(() => {
        if (shouldScroll) {
            scrollToForm();
            setShouldScroll(false);
        }
    }, [shouldScroll]);

    if (!job) {
        return <div>Job not found</div>;
    }

    return (
        <div className="page-for-job-apply-container container">
            <div className="page-for-job-apply-section section-1">
                <div className="page-for-job-apply-section-content text">
                    <h1>{job.title}</h1>
                    <p>Location: {job.location}</p>
                    <div className="button-section">
                        <a
                            className="btn"
                            onClick={(e) => {
                                e.preventDefault();
                                scrollToForm();
                            }}
                        >
                            <i className="bx bx-plus"></i>
                            Apply Now
                        </a>
                    </div>
                </div>
                <div className="page-for-job-apply-section-content">
                    <div className="image-container">
                        <img src={mainImage} alt="" />
                    </div>
                </div>
            </div>


            <div className='page-for-job-apply-section section-2'>
                <div className='page-for-job-apply-section-content text'>
                    <div className='job-description'>
                        <p>{job.description}</p>
                        <br />
                        <p>{job.aboutCompany}</p>
                        <br />
                        {
                            job.hire && <p>{job.hire}</p>
                        }
                        <br />
                        <p>{job.whatYouWillDo}</p>
                        <br />
                    </div>
                </div>
                <div className='page-for-job-apply-section-content text'>
                    {
                        job.keyOutcomes ? (<div className='job-key-outcomes'>
                            <h3>Key Responsibilities:</h3>
                            <ul>
                                {
                                    job.keyOutcomes.map((outcome, index) => (
                                        <li key={index}>
                                            <img src={plusIcon} alt="" />
                                            {outcome}
                                        </li>
                                    ))
                                }
                            </ul>
                        </div>) : (
                            <div className='job-key-outcomes'>
                                <h3>Patient Rounding:</h3>
                                <ul>
                                    {
                                        job.patientRounding.map((point, index) => (
                                            <li key={index}>
                                                <img src={plusIcon} alt="" />
                                                {point}
                                            </li>
                                        ))
                                    }
                                </ul>
                            </div>
                        )
                    }
                </div>
                <div className='page-for-job-apply-section-content text'>
                    {
                        job.requiredSkills ? (<div className='important-skills'>
                            <h3>Key Skills Required:</h3>
                            <ul>
                                {
                                    job.requiredSkills.map((skill, index) => (
                                        <li key={index}>
                                            <img src={plusIcon} alt="" />
                                            {skill}
                                        </li>
                                    ))
                                }
                            </ul>
                        </div>) : (
                            <div className='job-key-outcomes'>
                                <h3>APP Supervision:</h3>
                                <ul>
                                    {
                                        job.appSupervision.map((point, index) => (
                                            <li key={index}>
                                                <img src={plusIcon} alt="" />
                                                {point}
                                            </li>
                                        ))
                                    }
                                </ul>
                            </div>
                        )
                    }

                </div>
                <div className='page-for-job-apply-section-content text'>
                    {
                        job.preferredSkills ? (
                            <div className='preferred-skills'>
                                <h3>Desired Skills (but not required):</h3>
                                <ul>
                                    {
                                        job.preferredSkills.map((skill, index) => (
                                            <li key={index}>
                                                <img src={plusIcon} alt="" />
                                                {skill}
                                            </li>
                                        ))
                                    }
                                </ul>
                            </div>
                        ) : (
                            <div className='job-key-outcomes'>
                                <h3>SNF Partnerships</h3>
                                <ul>
                                    {
                                        job.snfPartnerships.map((point, index) => (
                                            <li key={index}>
                                                <img src={plusIcon} alt="" />
                                                {point}
                                            </li>
                                        ))
                                    }
                                </ul>
                            </div>
                        )
                    }
                </div>
                <div className='page-for-job-apply-section-content text'>
                    {
                        job.compensation ? (
                            <div className='compensation'>
                                <h3>Compensation:</h3>
                                <p>{job.compensation}</p>
                            </div>
                        ) : (
                            <>
                                <p>If any of the above partnership opportunities are of interest or if you have questions, we’d love to hear from you!</p>
                                <br />
                                <p>Anticipated Compensation</p>
                                <br />
                                <div>
                                    <h3>We offer a generous and customizable revenue-sharing model.</h3>
                                    <ul>
                                        <li><img src={plusIcon} alt="" /> <p><strong>Direct patient care: </strong>$340K – $520K per year for full time 5 days/week of clinical care</p> </li>
                                        <li><img src={plusIcon} alt="" /> <p><strong>APP Supervision: </strong>$40K – $80K per APP per year</p> </li>
                                    </ul>
                                </div>
                                <br />
                                <p>Your exact earnings will depend on the ways in which you partner with us and your ability to grow and strengthen the clinical practice. We’re happy to share more details during the interview process. </p>
                            </>
                        )
                    }
                </div>
                <div className='page-for-job-apply-section-content text'>
                    <div className='vaccination-policy'>
                        <h3>Vaccinations & Credentials:</h3>
                        <p>{job.vaccinationPolicy}</p>
                    </div>
                </div>
                <div className='page-for-job-apply-section-content text'>
                    {job.mission ? (
                        <div className='mission'>
                            <h3>Why Join Us?</h3>
                            <p>{job.mission}</p>
                        </div>
                    ) : (
                        <div className='mission'>
                            <h3>Interested? Here’s what you should know:</h3>
                            <p>{job.youShouldKnow}</p>
                        </div>
                    )
                    }

                </div>
                {job.benefits &&
                    <>
                        <div className='page-for-job-apply-section-content text'>
                            <div className='benefits'>
                                <h3>Benefits for full-time W-2 employees include:</h3>
                                <ul>
                                    {
                                        job.benefits.map((benefit, index) => (
                                            <li key={index}>
                                                <img src={plusIcon} alt="" />
                                                {benefit}
                                            </li>
                                        ))
                                    }
                                </ul>
                            </div>
                        </div>
                    </>
                }

                <div className='page-for-job-apply-section-content text'>
                    <div className='company-info'>
                        <h3>More about us:</h3>
                        <ul>
                            {job.companyInfo.map((info, index) => {
                                const [title, description] = info.split(':');
                                return (
                                    <li key={index}>
                                        <img src={plusIcon} alt="" />
                                        <p><strong>{title}:</strong>{description}</p>
                                    </li>
                                );
                            })}
                        </ul>
                        <br />
                        <p>If you’re motivated by our mission and want to contribute to our team, we’d love to hear from you.</p>
                    </div>
                </div>
            </div>
            <div ref={formRef}>
                <JobApplicationForm id="job-application-form" jobSpecificFields={jobSpecificFields}
                    jobTitle={decodedJobTitle} />
            </div>

            <CommonInsuranceSection />
            <FooterSection />
        </div>
    );
};

export default PageForJobApply;
